<div class="grid p-fluid">
  <div class="col-12">
    <div class="card">
      <h5 class="centerText">
        <span translate>SENSORS.SENSOR</span><span *ngIf="id"> {{ id }}</span>
        <span *ngIf="locationName"> - {{ locationName }}</span>
      </h5>
      <p-chart type="line" [data]="lineData"></p-chart>
    </div>
  </div>
</div>

